import {Accordion, AccordionDetails, styled} from '@mui/material';

const StyledAccordion = styled(Accordion)`
	border: none;
	box-shadow: none;
	border-radius: 8px;
`;

const StyledAccordionDetails = styled(AccordionDetails)`
	padding: 16px 16px 24px;

	${({theme}) => theme.breakpoints.down('md')} {
		padding-top: 0px;
	}
`;

export {StyledAccordion, StyledAccordionDetails};
